import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { NewRecordForm } from "pages/Backoffice/ApplicationPage/tabs/NewRecord";

type NewRecordStateType = {
	applicationId?: string;
} & NewRecordForm;

export const initialStateNewRecord: NewRecordStateType = {
	applicationId: "",
	action: null,
	comment: "",
	commentDocuments: [],
	response: "",
	responseDocuments: []
};

export const newRecordSlice = createSlice({
	name: "newRecord",
	initialState: initialStateNewRecord,
	reducers: {
		setValues: (state, action: PayloadAction<NewRecordStateType>) => {
			state.applicationId = action.payload.applicationId;
			state.action = action.payload.action;
			state.comment = action.payload.comment;
			state.commentDocuments = action.payload.commentDocuments;
			state.response = action.payload.response;
			state.responseDocuments = action.payload.responseDocuments;
		},
		reset: () => initialStateNewRecord
	}
});

export const { setValues, reset } = newRecordSlice.actions;
export default newRecordSlice.reducer;
